import { useSelector,useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import BackArrow from "@/components/Logos/BackArrow";
import { useRouter } from "next/compat/router";
import { getCookie, setCookie } from "cookies-next";
import { showPwaLoader } from "@/redux/actions/pwaAction";


export default function MobileBackNavigation() {
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const [showBack, setShowBack] = useState(false);
  const router = useRouter();
  const dispatch = useDispatch();
  const setPwaLoader = (e) => {
    dispatch(showPwaLoader(true)) 
  }
  
  useEffect(() => {
    if (window?.history?.state?.url != '/' && !router.asPath.startsWith('/?pk_vid') && !router.asPath.includes("/account") && router.asPath !== "/impact" && router.asPath !== "/designer" && !router.asPath.includes("/login") && !router.asPath.includes("/register") ) {
      setShowBack(true);
    }
  }, []);
  
  // try {
  //   let currentUrl = getCookie("currentUrl");
  //   let backButtonClicked = getCookie("backButtonClicked");
  //   if(backButtonClicked === "true") {
  //     setCookie("backButtonClicked", "false");
  //     backButtonClicked = "false";
  //   } else {
  //     if(!currentUrl || router.asPath === '/') {
  //       setCookie("backNavArray", JSON.stringify(['/']));
  //       setCookie("currentUrl",router.asPath)
  //     } else {
  //       let backNavArray = JSON.parse(getCookie("backNavArray"));
  //       if(currentUrl != router.asPath) {
  //         backNavArray.push(currentUrl);
  //         if(backNavArray.length > 10) {
  //           backNavArray = backNavArray.slice(2);
  //         }
  //         setCookie("backNavArray", JSON.stringify(backNavArray));
  //         setCookie("currentUrl", router.asPath);
  //       }
  //     }
  //   }
  // } catch (e) {
  //   setCookie("backNavArray", JSON.stringify(['/']));
  //   setCookie("currentUrl",router.asPath)
  // }
  
  
  const handleClick = (e) => {
    e.preventDefault()
    setPwaLoader()
    if (typeof window !== 'undefined') {
      const referrer = document.referrer; // Get the previous page URL
      if (router.asPath.includes("/your-bag")) {
        if (referrer.includes("checkout.olivela.com") || referrer.includes("/recommended-for-you")) { //updated url to check for checkout
            // If the user came from /checkout or /recommended-for-you, navigate to /xyz
            window.location.href = '/';
        } else {
            // Otherwise, navigate to the root
            window.history?.back();
        }
      } else {
          // Go back in history
          window.history?.back();
      }
  }
    // try{
    //   let backNavArray = JSON.parse(getCookie("backNavArray"));
    //   let previousUrl = backNavArray.length >=1 ? backNavArray.pop() : '/';
    //   if(!backNavArray.length) {
    //     backNavArray = ['/']
    //   }
    //   setCookie("backNavArray", JSON.stringify(backNavArray));
    //   setCookie("currentUrl", previousUrl);
    //   setCookie("backButtonClicked", "true");
    //   window.location.href = previousUrl;
    // }
    // catch(e){
    //   window.location.href = '/';
    // }
    
  }
  return (
    <>
    {isPWA && showBack && <div className={`back_arrow`} onClick={(e) => {handleClick(e);}}>
        <BackArrow height="19" stroke={"#2f2f30"} />
      </div>}
    </>
  );
}
